// omit specified field
export const omitSingle = (key, { [key]: _, ...obj }) => obj

/**
 *
 * @param array
 * @param value array after add the value
 */
export const add = (array, value) => {
  if (array.indexOf(value) === -1) {
    array.push(value)
  }
}

/**
 *
 * @param array
 * @param value array removed add the value
 */
export const remove = (array, value) => {
  const index = array.indexOf(value)
  if (index !== -1) {
    array.splice(index, 1)
  }
}
